import { render, staticRenderFns } from "./SubContent.vue?vue&type=template&id=f47fc6c6"
import script from "./SubContent.vue?vue&type=script&lang=js"
export * from "./SubContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports